import { render, staticRenderFns } from "./AppGuide.component.vue?vue&type=template&id=4c207450&scoped=true&"
import script from "./AppGuide.component.vue?vue&type=script&lang=js&"
export * from "./AppGuide.component.vue?vue&type=script&lang=js&"
import style0 from "./AppGuide.component.vue?vue&type=style&index=0&id=4c207450&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c207450",
  null
  
)

export default component.exports